import {
  AdminUserPermissionGroupListRequest,
  AdminUserPermissionGroupListResponse,
  AdminUserPermissionGroupUpdateRequest,
  AdminUserPermissionGroupUpdateResponse,
} from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export default class UserResourcePermissionGroupsService {
  public list(request: AdminUserPermissionGroupListRequest): Promise<AxiosResponse<AdminUserPermissionGroupListResponse>> {
    return axios.post<AdminUserPermissionGroupListResponse>('/api/admin/users/resource-permissions/groups/list', request);
  }

  public update(request: AdminUserPermissionGroupUpdateRequest): Promise<AxiosResponse<AdminUserPermissionGroupUpdateResponse>> {
    return axios.post<AdminUserPermissionGroupUpdateResponse>('/api/admin/users/resource-permissions/groups/update', request);
  }
}
